import json from "../package.json";
import ReactDOM from "react-dom/client";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { PackageService } from "namirasoft-core";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";

PackageService.MainJson = json;
PackageService.ThisJson = json;

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

// base
const REACT_APP_BASE_PATH = process.env.REACT_APP_BASE_PATH;
if (REACT_APP_BASE_PATH)
{
    const baseElement = document.createElement('base');
    baseElement.href = REACT_APP_BASE_PATH + "/";
    const head = document.querySelector('head');
    head?.appendChild(baseElement);
}

root.render(
    <BrowserRouter>
        <Router />
    </BrowserRouter>
);